import ButtonBase from '@material-ui/core/ButtonBase';
import Icon from '@material-ui/core/Icon';
import MyTable, { MyTableBody, MyTableCol, MyTableRow } from 'components/MyTable';
import React from 'react';

import type { Step } from 'react-joyride';

export const productTourSteps: Step[] = [
  {
    target: '#myProductsList',
    content: (
      <div>
        <div>As ações e os detalhes referentes aos seus produtos são encontrados nesse botão no final da linha</div>
        <div>
          <MyTable>
            <MyTableBody>
              <MyTableRow key={'sales-row-1'}>
                <MyTableCol numeric action screenSizes={{ xs: 12, sm: 1, md: 6, lg: 3 }}>
                  <ButtonBase>
                    <Icon>more_horiz</Icon>
                  </ButtonBase>
                </MyTableCol>
              </MyTableRow>
            </MyTableBody>
          </MyTable>
        </div>
      </div>
    ),
  },
  {
    target: '#myNewProductButton',
    content: ' Aqui você consegue criar seu produto de uma maneira fácil e rápida, crie e saia vendendo!',
  },
];
